import { Route, Routes } from 'react-router-dom';
import Layout from 'components/layout';
import { TemplateBuilder, Verification, DownloadEmail, DownloadMeetingSignature } from './pages';

export const routes = [
  {
    path: '/',
    element: TemplateBuilder,
  },
  {
    path: '/verification',
    element: Verification,
  },
  {
    path: '/download',
    element: DownloadEmail,
  },
  {
    path: '/download-meeting-signature',
    element: DownloadMeetingSignature,
  },
];

const Router = () => {
  return (
    <Routes>
      {routes.map(({ element: Element, path, authContent, ...rest }) => (
        <Route
          path={path}
          element={
            <Layout>
              <Element />
            </Layout>
          }
          key={path}
        />
      ))}
      <Route
        path="*"
        element={
          <Layout>
            <TemplateBuilder />
          </Layout>
        }
      />
    </Routes>
  );
};

export default Router;
